import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Flex, Text } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

export type RoleState = {
  isOwner: boolean;
  isController: boolean;
  ownershipPercentage: number;
};

export const AutoProfileCreationCard = () => {
  const history = useHistory();
  const location = useLocation();
  const { values } = useFormContext<RoleState>();

  const handleOpenModal = useCallback(
    () =>
      history.push({
        pathname: `${location.pathname}/extraction`,
        search: location.search,
        state: {
          isOwner: values.isOwner,
          isController: values.isController,
          ownershipPercentage: values.ownershipPercentage,
        } satisfies RoleState,
      }),
    [
      history,
      location.pathname,
      location.search,
      values.isOwner,
      values.isController,
      values.ownershipPercentage,
    ],
  );

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        gap={20}
        className={styles.container}
      >
        <Flex flexDirection="column" gap={Sizes.XS}>
          <Flex gap={Sizes.XS}>
            <Icon type="regular-file-sparkle" size="large" />
            <Text variant="strong-md" className={styles.title}>
              Auto-create profile with an identification document
            </Text>
          </Flex>
          <Text variant="regular-md" className={styles.description}>
            Using document extracted data, we&apos;ll help you get started
          </Text>
        </Flex>
        <Button variant="neutral" icon="arrow-up-from-bracket" onClick={handleOpenModal}>
          Upload document
        </Button>
      </Flex>
    </>
  );
};
